var hornstrup = hornstrup || {};
hornstrup.share = hornstrup.share || function () {
    //share links must have these id's: share-facebook share-twitter share-linkedin
    var self = this;
    var arrayUrlPrefixes = {
        facebook:'http://www.facebook.com/sharer/sharer.php?u=',
        linkedin:'https://www.linkedin.com/cws/share?url=',
        twitter:'https://twitter.com/home?status=',
        email: 'mailto:?subject=Se dette på Hornstrup Kursuscenters website&body=Se her: ',
    }

    this.init = function (callback) {

        $('#social-media-share a:not("#share-download")').on('click',function(e){
             e.preventDefault();
             var socialMediaType = self.getSocialMediaType(this);
             var link = self.buildLink(socialMediaType);
             if(socialMediaType=="email"){
                location.href=link;
             }else{
                self.openShareWindow(socialMediaType,link);
             }
        });
    }
    this.getSocialMediaType = function (elem) {
        var socialType = $(elem).attr('id').replace('share-','');
        return socialType;
    }
    this.buildLink = function (socialMediaType) {
        var url = document.location.href;
        var encodedUrl = encodeURIComponent(url);
        var linkPrefix=arrayUrlPrefixes[socialMediaType]
        return linkPrefix + encodedUrl;
    }
    this.openShareWindow = function (socialMediaType, link) {
        window.open(link, 'share_'+socialMediaType, 'width=600,height=465');
    }

    // public functions:
    return {
        init: init
    };
}();

